import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import { UploadMedia } from '../../../../../../common/components/common/upload-media';
import PlansBasicInfoComponent from './plans-basic-info.component';
import PlansValuesComponent from './plans-table-info.component';

export const PlansComponent = ({ selectedPlansValues, AccountTypes, Accounts,
    id, PolicyOwnerType, campaignFrequency, onFormItemChange, selectedPlans,
    columnDefs, handleEdit, additionButtons, handleDelete, onInnerBasicFormChange, back, handleFormSubmit }: any) => {


    const handleInnerMediaFormChange: any = ({ field, value }: any) => {
        onFormItemChange({
            value: value.MediaFiles,
            field: 'MediaFiles',
            idx: '',
        });
    };

    const tabItems = [
        {
            id: 1,
            title: 'Basic-Info',
            component: (
                <PlansBasicInfoComponent
                    onInnerBasicFormChange={onInnerBasicFormChange}
                    selectedPlans={selectedPlans}
                    campaignFrequency={campaignFrequency}
                    PolicyOwnerType={PolicyOwnerType}
                    AccountTypes={AccountTypes}
                    Accounts={Accounts}
                />
            ),
            isVisible: true,
        },

        {
            id: 2,
            title: 'Plans',
            component:
                <PlansValuesComponent
                    handleDelete={handleDelete}
                    additionButtons={additionButtons}
                    handleEdit={handleEdit}
                    columnDefs={columnDefs}
                    onInnerBasicFormChange={onInnerBasicFormChange}
                    selectedPlansValues={selectedPlansValues}
                />,
            isVisible: true,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end h-20'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}
export default PlansComponent;
